/** Häufige deutschsprachige & internationale Vornamen → Geschlecht ableiten
 *  Keys möglichst ohne Umlaute (wie nach normalizeToken), plus gängige Schreibweisen.
 */

const MALE = new Set([
  // A
  'aaron', 'abas', 'abbas', 'abdullah', 'achim', 'adalbert', 'adam', 'adelbert', 'adem', 'adnan',
  'adolfo', 'adolf', 'adrian', 'adriano', 'ahmad', 'ahmed', 'ahmet', 'aiden', 'akin', 'alain',
  'alan', 'alban', 'albert', 'alberto', 'albin', 'albrecht', 'aldo', 'aleksandar', 'aleksander',
  'alessandro', 'alex', 'alexander', 'alexandre', 'alexis', 'alf', 'alfons', 'alfonso', 'alfred',
  'alfredo', 'ali', 'alois', 'alonso', 'alwin', 'amadeus', 'aman', 'amin', 'amir', 'amos',
  'anastasios', 'anatoli', 'anatoly', 'anders', 'andi', 'andre', 'andreas', 'andrei',
  'andrej', 'andres', 'andrew', 'andro', 'andy', 'angel', 'angelo', 'anil', 'ansgar',
  'anthony', 'antoine', 'anton', 'antonino', 'antonio', 'antony', 'anwar', 'apostolos', 'aral',
  'arda', 'ari', 'arian', 'arif', 'arkadius', 'arkadiusz', 'armin', 'arnim', 'arno', 'arnold',
  'aron', 'arthur', 'artur', 'arturo', 'arvid', 'aryan', 'aslan', 'attila', 'august', 'augustin',
  'augustus', 'aurelio', 'austin', 'axel', 'aydin', 'ayhan',
  // B
  'balthasar', 'baran', 'barnabas', 'barry', 'bart', 'bartholomaus', 'bartholomeus', 'basil',
  'bastian', 'bayram', 'ben', 'benedikt', 'benito', 'benjamin', 'bennet', 'benno', 'benny',
  'bent', 'berk', 'bernard', 'bernardo', 'bernd', 'bernhard', 'bert', 'berthold', 'bertram',
  'bilal', 'bjarne', 'bjorn', 'bjoern', 'blake', 'bojan', 'boris', 'borislav', 'bradley', 'brian',
  'bruno', 'bryan', 'burak', 'burkhard',
  // C
  'caesar', 'cahit', 'caleb', 'calvin', 'can', 'carl', 'carlo', 'carlos', 'carsten', 'caspar',
  'casper', 'cedric', 'cem', 'cemal', 'cengiz', 'cesar', 'charles', 'charlie', 'chris',
  'christian', 'christof', 'christoph', 'christopher', 'claude', 'claudio', 'claus', 'clemens',
  'clement', 'colin', 'collin', 'conner', 'connor', 'conor', 'constantin', 'constantinos',
  'cosimo', 'craig', 'curtis',
  // D
  'damian', 'damien', 'damir', 'dan', 'dani', 'daniel', 'daniele', 'danilo', 'danny', 'dante',
  'darius', 'dariusz', 'darko', 'dave', 'david', 'davide', 'davin', 'dean', 'denis',
  'dennis', 'derek', 'desmond', 'detlef', 'detlev', 'devin', 'diego', 'dieter', 'dietmar',
  'dietrich', 'dimitri', 'dimitrios', 'dino', 'dirk', 'dominic', 'dominik', 'donald',
  'dragan', 'dylan',
  // E
  'ebbe', 'eckart', 'eckhard', 'eddie', 'edgar', 'edison', 'edmond', 'edmund', 'edoardo', 'eduard',
  'eduardo', 'edward', 'edwin', 'egon', 'ekkehard', 'elan', 'elias', 'elijah', 'elio', 'elliot',
  'elliott', 'elmar', 'emanuel', 'emilio', 'emil', 'emir', 'emmanuel', 'emre', 'enrico', 'enrique',
  'enzo', 'ephraim', 'erdal', 'erdogan', 'eric', 'erik', 'ernest', 'ernst', 'erol', 'erwin',
  'ethan', 'eugene', 'eugen', 'evan', 'everett', 'ezio',
  // F
  'fabian', 'fabio', 'falk', 'farid', 'faruk', 'federico', 'felix', 'ferdinand',
  'ferhat', 'fernando', 'filip', 'filippo', 'finn', 'finnley', 'firat', 'flavio', 'florentin',
  'florian', 'francesco', 'francis', 'francisco', 'franco', 'frank', 'franz', 'franziskus',
  'fred', 'freddy', 'frederick', 'frederik', 'fredrik', 'fridolin', 'friedemann', 'friedhelm',
  'friedrich', 'fritz', 'fynn',
  // G
  'gabriel', 'gael', 'gabor', 'gene', 'georg', 'george', 'georges', 'gerald', 'gerard', 'gerd',
  'gerhard', 'germain', 'gerrit', 'gert', 'gian', 'gianluca', 'gianni', 'giacomo', 'gilbert',
  'gioele', 'giorgio', 'giovanni', 'giuliano', 'giuseppe', 'glen', 'glenn', 'goran', 'gordon',
  'gottfried', 'gotthard', 'gregor', 'gregory', 'guido', 'gunnar', 'gunter', 'guenter', 'gunther',
  'guenther', 'gustav', 'guy',
  // H
  'habib', 'hagen', 'haider', 'hakan', 'hakim', 'halil', 'hamid', 'hamza', 'hannes',
  'hanno', 'hans', 'hansjorg', 'hansjoerg', 'harald', 'hardy', 'haris', 'harold',
  'harry', 'hartmut', 'hasan', 'hassan', 'heiko', 'heiner', 'heinrich', 'heinz', 'helge',
  'helmut', 'helmuth', 'hendrik', 'henning', 'henri', 'henrik', 'henry', 'herbert', 'heribert',
  'herman', 'hermann', 'hilmar', 'hinrich', 'holger', 'horst', 'hubert', 'hubertus', 'hugo',
  'huseyin', 'hussein',
  // I
  'ian', 'ibrahim', 'ignatz', 'ignaz', 'igor', 'ilhan', 'ilias', 'ilja', 'ilyas', 'imran',
  'ingo', 'ingolf', 'ioannis', 'irakli', 'isaac', 'isak', 'ismail', 'ivan', 'ivo', 'iwan',
  // J
  'jack', 'jackson', 'jacob', 'jacques', 'jaden', 'jaime', 'jake', 'jakob', 'jakub',
  'james', 'jamie', 'jamal', 'jan', 'janek', 'jani', 'janis', 'jannik', 'jannis', 'janos',
  'janosch', 'jared', 'jaroslav', 'jascha', 'jason', 'jasper', 'javier', 'jay', 'jean', 'jeff',
  'jeffrey', 'jens', 'jeremias', 'jeremy', 'jeroen', 'jerome', 'jerry', 'jim', 'jimmy', 'joachim',
  'jochen', 'joe', 'joel', 'joerg', 'jorg', 'joey', 'johann', 'johannes', 'john', 'johnny',
  'jon', 'jonas', 'jonathan', 'jonny', 'jorge', 'joris', 'joscha', 'josef', 'joseph', 'josh',
  'joshua', 'josiah', 'josip', 'jose', 'juan', 'julian', 'julien', 'julius', 'juri', 'jurgen',
  'juergen', 'justin', 'justus',
  // K
  'kaan', 'kai', 'kamil', 'karl', 'karlheinz', 'karlo', 'karsten', 'kasimir', 'kaspar', 'kay',
  'kazim', 'kemal', 'kenan', 'kenneth', 'kenny', 'kerem', 'kevin', 'kian', 'kilian',
  'kjell', 'klaus', 'kolja', 'konrad', 'konstantin', 'koray', 'korbinian',
  'kristian', 'kristofer', 'kristof', 'kurt', 'kyle',
  // L
  'lars', 'lasse', 'laurenz', 'lawrence', 'leander', 'leif', 'lennard', 'lennart', 'lennox',
  'lenny', 'leo', 'leon', 'leonard', 'leonardo', 'leonhard', 'leopold', 'levin', 'levon', 'lewis',
  'liam', 'linus', 'lion', 'lionel', 'lloyd', 'logan', 'loic', 'lorenz', 'lorenzo', 'lothar',
  'louis', 'luc', 'luca', 'lucas', 'lucian', 'luciano', 'ludger', 'ludovic', 'ludwig',
  'luigi', 'luis', 'lukas', 'luke', 'lutz',
  // M
  'maarten', 'magnus', 'mahmoud', 'maik', 'malik', 'malte', 'manfred', 'mani', 'manuel', 'marc',
  'marcel', 'marcello', 'marcin', 'marco', 'marcus', 'marek', 'mariano', 'mario', 'marius',
  'mark', 'marko', 'markus', 'marlon', 'martin', 'marvin', 'mason', 'massimo', 'mateo', 'mateusz',
  'mathias', 'mathieu', 'mathis', 'matteo', 'matthew', 'matthias', 'mattias', 'maurice', 'maurizio',
  'max', 'maxim', 'maximilian', 'mehmet', 'meinhard', 'melvin', 'merlin', 'mesut', 'micael',
  'michael', 'michel', 'michele', 'miguel', 'mihail', 'mike', 'milan', 'milo', 'milos', 'mirco',
  'mirko', 'miro', 'miroslav', 'mischa', 'mitchell', 'mohamed', 'mohammad', 'mohammed',
  'moritz', 'morris', 'moses', 'muammer', 'murat', 'mustafa',
  // N
  'nabil', 'nando', 'nathan', 'nathanael', 'nathaniel', 'nedim', 'neil', 'nelson', 'neo',
  'neven', 'nic', 'nicholas', 'nick', 'nico', 'nicolas', 'nicolo', 'niels', 'nikita', 'niklas',
  'niko', 'nikola', 'nikolai', 'nikolas', 'nikolaus', 'nils', 'nino', 'noah', 'noel', 'norbert',
  'norman',
  // O
  'ole', 'oleg', 'oliver', 'olivier', 'omar', 'omer', 'orlando', 'orhan', 'oscar',
  'oskar', 'osman', 'otmar', 'otto', 'ozan', 'ozgur',
  // P
  'paolo', 'pascal', 'pasquale', 'patrik', 'patrick', 'patryk', 'paul', 'paulo', 'paulus',
  'pedro', 'peer', 'per', 'pete', 'peter', 'petrus', 'phil', 'philip', 'phillip', 'philipp',
  'philippe', 'pierre', 'piotr',
  // Q–R
  'quentin', 'rafael', 'raffaele', 'rainer', 'ralf', 'ralph', 'ramazan', 'rami',
  'ramon', 'randall', 'randy', 'raoul', 'raphael', 'raul', 'ray', 'raymond', 'reece',
  'reiner', 'reinhard', 'reinhold', 'remco', 'remi', 'remy', 'rene', 'renzo', 'reto', 'ricardo',
  'riccardo', 'richard', 'rick', 'ricky', 'rico', 'riza', 'robert', 'roberto', 'rocco',
  'rodney', 'roger', 'roland', 'rolf', 'roman', 'romeo', 'ron', 'ronald', 'ronny', 'rory',
  'roy', 'ruben', 'rudolf', 'rudolph', 'rufus', 'rupert', 'ruslan', 'ryan',
  // S
  'said', 'salah', 'salem', 'salim', 'sam', 'sami', 'samir', 'samuel', 'samy', 'sander',
  'sandro', 'santino', 'sascha', 'scott', 'sean', 'sebastian', 'sebi', 'selim',
  'semih', 'serdar', 'serge', 'sergei', 'sergej', 'sergio', 'severin', 'shahin',
  'sidney', 'siegfried', 'siegmund', 'sigurd', 'silas', 'silvio', 'simon', 'soeren',
  'soren', 'stanislav', 'stanley', 'stefan', 'stefano', 'steffen', 'stephan', 'stephen',
  'steve', 'steven', 'stijn', 'stuart', 'sven', 'syed', 'sylvester',
  // T
  'taha', 'tamim', 'tamino', 'tarik', 'tarkan', 'teddy', 'teodor', 'terry', 'theo',
  'theodor', 'theodore', 'thilo', 'thomas', 'thor', 'thorben', 'thorsten', 'tiago', 'tibor',
  'till', 'tim', 'timmy', 'timo', 'timon', 'timothy', 'tino', 'titus', 'tobias', 'toby', 'tom',
  'tomas', 'tomasz', 'tomislav', 'tommy', 'toni', 'tony', 'torben', 'torsten', 'tristan',
  'troy', 'tyler',
  // U–Z
  'udo', 'ulf', 'uli', 'ulrich', 'umberto', 'umut', 'uwe', 'vadim', 'valentino', 'valentin',
  'valerio', 'vasile', 'vasili', 'veit', 'victor', 'viktor', 'vince', 'vincent',
  'vincenzo', 'vito', 'vladimir', 'volker', 'volkert', 'wade', 'waldemar', 'wallace', 'walter',
  'warren', 'wayne', 'wendel', 'wendelin', 'werner', 'wesley', 'wilfried', 'wilhelm', 'willi',
  'william', 'willibald', 'willy', 'wilmer', 'winfried', 'wladimir', 'wojciech', 'wolf',
  'wolfgang', 'wolfram', 'xander', 'xaver', 'xavier', 'yakup', 'yanis', 'yann', 'yannick',
  'yannik', 'yannis', 'yasin', 'yavuz', 'yilmaz', 'younes', 'youssef', 'yusuf', 'zacharias',
  'zachary', 'zafer', 'zayn', 'zoltan',
]);

const FEMALE = new Set([
  // A
  'abby', 'abigail', 'ada', 'adela', 'adelaide', 'adele', 'adelheid', 'adelina', 'adina',
  'adriana', 'adriane', 'adrienne', 'agatha', 'agnes', 'aglaja', 'ahsen', 'aida', 'aila',
  'ailin', 'aimee', 'aina', 'aischa', 'aisha', 'alaia', 'alara', 'alberta', 'albina', 'alejna',
  'aleksandra', 'alena', 'alesia', 'alessandra', 'alessia', 'alexa', 'alexandria', 'alexandra',
  'alexia', 'aliya', 'alice', 'alicia', 'alina', 'aline', 'alisa', 'alisha', 'alison', 'alissa',
  'aliyah', 'allegra', 'alma', 'almut', 'almuth', 'aloisia', 'alva', 'alwina', 'alwine', 'alya',
  'amalia', 'amalie', 'amanda', 'amaya', 'amber', 'amelia', 'amelie', 'amina', 'amira', 'amy',
  'ana', 'anastasia', 'anastasija', 'anca', 'andrea', 'andreea', 'anette', 'angela', 'angelica',
  'angelika', 'angelina', 'angie', 'anika', 'anina', 'anita', 'anja', 'ann', 'anna', 'annabell',
  'annabella', 'annabelle', 'anne', 'annegret', 'annelie', 'anneliese', 'annemarie', 'annette',
  'anni', 'annie', 'annika', 'annina', 'anouk', 'antje', 'antonella', 'antonia', 'antonietta',
  'anu', 'anya', 'apollonia', 'ariana', 'ariane', 'arianna', 'arzu', 'asha', 'asia',
  'asli', 'asya', 'astrid', 'athena', 'aubrey', 'audrey', 'aurelia', 'aurora', 'ava', 'ayla',
  'aylin', 'ayse', 'aysel', 'aysha', 'aysu', 'azra',
  // B
  'babette', 'bailey', 'barbara', 'barbra', 'basak', 'bea', 'beata', 'beate', 'beatrice',
  'beatrix', 'becca', 'belinda', 'bella', 'benedikta', 'berivan', 'berenice',
  'berit', 'berna', 'berta', 'bertha', 'betty', 'bettina', 'bianca', 'bianka', 'bibi', 'birgit',
  'birgitt', 'birte', 'blair', 'blanca', 'blanka', 'bozena', 'brenda', 'brianna', 'brigitta',
  'brigitte', 'britney', 'britta', 'brooke', 'brooklyn', 'burcu',
  // C
  'cahide', 'caitlin', 'camila', 'camilla', 'camille', 'candice', 'cara', 'caren', 'carina',
  'carla', 'carlotta', 'carmen', 'carol', 'carola', 'carolin', 'carolina', 'caroline', 'carolyn',
  'carys', 'catalina', 'catarina', 'caterina', 'catharina', 'catherine', 'cathleen', 'cathrin',
  'cathy', 'cayla', 'cecilia', 'cecile', 'celia', 'celina', 'celine', 'ceren', 'chanel',
  'chantal', 'charlene', 'charlotte', 'chelsea', 'cheyenne', 'chiara', 'chloe', 'christa',
  'christel', 'christiane', 'christina', 'christine', 'cindy', 'claire', 'clara', 'clare',
  'clarissa', 'claudia', 'clemence', 'clementine', 'cleo', 'coco', 'coleen', 'colleen',
  'constance', 'constanze', 'cora', 'coral', 'coralie', 'cordula', 'corinna', 'corinne',
  'cornelia', 'cosima', 'cristina', 'cynthia',
  // D
  'dagmar', 'daisy', 'dalia', 'damla', 'dana', 'daniela', 'daniella', 'danielle', 'danica',
  'daphne', 'daria', 'darija', 'davina', 'dawn', 'debbie', 'deborah', 'defne', 'delia',
  'denise', 'desiree', 'destiny', 'diana', 'diane', 'dianne', 'dilara', 'dilek',
  'dina', 'dolores', 'dominika', 'donna', 'dora', 'doris', 'dorothea', 'dorothee', 'dunja',
  'duygu',
  // E
  'ebba', 'edeltraut', 'edith', 'edna', 'edda', 'eileen', 'ela', 'elaine', 'elena',
  'eleonora', 'eleonore', 'eliana', 'eliane', 'elif', 'elina', 'elin', 'elisa', 'elisabet',
  'elisabeth', 'elise', 'elizabeth', 'ella', 'ellen', 'elli', 'ellie', 'ellinor', 'elma',
  'elodie', 'elsa', 'else', 'elsbeth', 'elvira', 'elya', 'emanuela', 'emelie', 'emely',
  'emilia', 'emilie', 'emily', 'emina', 'emma', 'emmy', 'enya', 'erica', 'erika', 'erin',
  'erma', 'ernestine', 'esma', 'esra', 'estelle', 'esther', 'etta', 'eugenia', 'eunice',
  'eva', 'evalin', 'evangelia', 'evelin', 'eveline', 'evelyn', 'evelyne', 'evita',
  // F
  'fabienne', 'fabiola', 'faith', 'fanny', 'fatima', 'fatma', 'felicitas', 'felicity',
  'felina', 'feline', 'fernanda', 'filiz', 'fina', 'fiona', 'fleur', 'flora', 'florence',
  'florentine', 'frances', 'francesca', 'francine', 'franka', 'franziska', 'frederike',
  'freya', 'frida', 'frieda', 'friederike', 'fulya',
  // G
  'gabi', 'gabriela', 'gabriele', 'gabriella', 'gabrielle', 'gail', 'galina',
  'genoveva', 'georgia', 'georgina', 'geraldine', 'gerda', 'gerlinde', 'gertrud', 'gertrude',
  'gia', 'gianna', 'gigi', 'gilda', 'gina', 'ginny', 'giovanna', 'gisela', 'gisele', 'giselle',
  'gitta', 'giulia', 'giuliana', 'gloria', 'grace', 'greta', 'gretchen', 'gretel', 'gudrun',
  'gunhild', 'gul', 'gulay', 'gulsen',
  // H
  'habibe', 'hadley', 'hafsa', 'hala', 'halime', 'halle', 'hana', 'hanife', 'hanna', 'hannah',
  'hannelore', 'harper', 'hatice', 'hayley', 'hazal', 'heather', 'hedwig', 'heidi',
  'heike', 'helen', 'helena', 'helene', 'helga', 'heliane', 'helma', 'henriette', 'henrike',
  'hermina', 'hermine', 'hilal', 'hilda', 'hilde', 'hildegard', 'holly', 'hope',
  'hulya',
  // I
  'ida', 'ilayda', 'ilka', 'ilona', 'ilse', 'imane', 'imke', 'ina', 'ines', 'inga', 'inge',
  'ingeborg', 'inger', 'ingrid', 'inka', 'ioanna', 'ira', 'irene', 'irina', 'iris', 'irma',
  'irmgard', 'irmtraud', 'isabel', 'isabella', 'isabelle', 'isabell', 'isra', 'ivana', 'ivonne',
  // J
  'jacqueline', 'jade', 'jamila', 'jana', 'jane', 'janet', 'janina', 'janine',
  'janna', 'jannika', 'jasmin', 'jasmine', 'jeanette', 'jeannette', 'jeanne', 'jennifer',
  'jenny', 'jessie', 'jessica', 'jill', 'joana', 'joanna', 'joanne', 'jocelyn', 'joelle',
  'johanna', 'jolanda', 'jolanthe', 'josefa', 'josefine', 'josephine',
  'josie', 'joy', 'joyce', 'judith', 'judy', 'jule', 'julia', 'juliana', 'juliane', 'julie',
  'juliet', 'juliette', 'june', 'justina', 'justine', 'jutta',
  // K
  'kaija', 'kaja', 'karen', 'karin', 'karina', 'karla', 'karolina', 'karoline', 'kassandra',
  'katalin', 'katarina', 'kate', 'katharina', 'katherine', 'kathi', 'kathleen', 'kathrin',
  'kathy', 'katia', 'katie', 'katja', 'katrin', 'katy', 'kaya', 'kayla', 'keira', 'kelly',
  'kendra', 'kerstin', 'khadija', 'kiara', 'kimberly', 'kira', 'kirsten', 'kirstin',
  'klara', 'klarissa', 'konstanze', 'kora', 'krista', 'kristen', 'kristin', 'kristina',
  'kristine', 'krystyna', 'kunigunde',
  // L
  'laila', 'lana', 'lara', 'larissa', 'laura', 'laureen', 'lauren', 'laurence', 'lauretta',
  'lauryn', 'lavinia', 'layla', 'lea', 'leah', 'leandra', 'leila', 'lena', 'lene', 'lenja',
  'leni', 'lenya', 'leona', 'leonie', 'leonora', 'leontine', 'leticia', 'letizia', 'lexi',
  'lia', 'liana', 'liane', 'lidia', 'lidija', 'liesbeth', 'liesa', 'lieselotte', 'lili',
  'lilian', 'liliana', 'liliane', 'lilith', 'lilli', 'lillian', 'lilly', 'lily', 'lina',
  'linda', 'lindsay', 'line', 'linnea', 'lisa', 'lisann', 'lisbeth', 'lise', 'liselotte',
  'liv', 'livia', 'liz', 'liza', 'loane', 'lois', 'lola', 'lore', 'loreen', 'lorena',
  'lorraine', 'lotte', 'lotti', 'louisa', 'louise', 'luana', 'lucia', 'luciana',
  'lucie', 'lucy', 'ludmila', 'luisa', 'luise', 'lulu', 'luna', 'luzia', 'luzie', 'lydia',
  'lynn',
  // M
  'mabel', 'madeleine', 'madeline', 'madison', 'mae', 'magda', 'magdalena', 'maggie', 'maha',
  'maike', 'maja', 'mali', 'malia', 'malin', 'mandy', 'manuela', 'mara', 'marcella', 'mareike',
  'maren', 'margaret', 'margareta', 'margarete', 'margarita', 'margit', 'margot', 'margret',
  'maria', 'mariah', 'mariana', 'marianna', 'marianne', 'maribel', 'marie', 'mariechen',
  'mariella', 'marielle', 'marietta', 'marika', 'marilyn', 'marina', 'marine',
  'marion', 'marisa', 'marissa', 'marit', 'marita', 'marja', 'marlene', 'marlies', 'marlis',
  'marta', 'martha', 'martina', 'martine', 'mary', 'maryam', 'mathilde', 'matilda', 'maura',
  'maureen', 'maya', 'mayra', 'medina', 'meike', 'melanie', 'melina', 'melinda', 'melisa',
  'melissa', 'melody', 'mercedes', 'meret', 'merle', 'merve', 'mia', 'michaela',
  'michelle', 'mila', 'milena', 'milla', 'millie', 'mira', 'miray', 'miriam', 'mirjam',
  'mirjana', 'molly', 'mona', 'monica', 'monika', 'monique', 'muriel', 'myriam',
  // N
  'nada', 'nadia', 'nadine', 'nadja', 'nancy', 'naomi', 'natalia', 'natalie',
  'natascha', 'nathalie', 'nayla', 'nele', 'nelli', 'nelly', 'nena', 'nergis', 'nessa',
  'nicole', 'nicoletta', 'nicolette', 'nika', 'nikki', 'nila', 'nina', 'nine', 'nisa',
  'noelle', 'nora', 'norah', 'norma', 'nuray', 'nuria',
  // O
  'octavia', 'odette', 'olga', 'olivia', 'olympia', 'ophelia', 'oriana', 'ottilie', 'ozge',
  'ozlem',
  // P
  'paige', 'pamela', 'paola', 'patricia', 'patrizia', 'paula', 'paulette', 'paulina',
  'pauline', 'pearl', 'peggy', 'penelope', 'petra', 'petrina', 'philippa', 'pia', 'piper',
  'polly', 'priscilla',
  // R
  'rachael', 'rachel', 'raffaela', 'rahel', 'raina', 'ramona', 'raquel', 'rebecca', 'rebekka',
  'regina', 'regine', 'rena', 'renata', 'renate', 'renee', 'ria', 'rica', 'rikke', 'rina',
  'rita', 'roberta', 'romana', 'romina', 'ronja', 'rosa', 'rosalie', 'rosalinde',
  'rose', 'rosemarie', 'rosi', 'rosina', 'roswitha', 'roxana', 'roxane', 'ruth',
  // S
  'sibel', 'sabine', 'sabrina', 'sade', 'sadie', 'saffa', 'sahra', 'sally', 'salma', 'salome',
  'samantha', 'samira', 'sandra', 'sandy', 'sara', 'sarah', 'sarina', 'saskia', 'savannah',
  'scarlett', 'selda', 'selin', 'selina', 'selma', 'serena', 'serpil', 'sevil', 'sharon',
  'sheila', 'shelley', 'shirin', 'sibylle', 'sidonie', 'sienna', 'sigrid', 'silja', 'silke',
  'silvana', 'silvia', 'simone', 'simona', 'sinead', 'sofia', 'sofie', 'sonia', 'sonja',
  'sophia', 'sophie', 'stacey', 'stella', 'stephanie', 'stefanie', 'steffi', 'stina', 'susan',
  'susana', 'susanna', 'susanne', 'susi', 'suzanne', 'suzie', 'svetlana', 'svenja', 'swetlana',
  'sydney', 'sylvia', 'sylvie',
  // T
  'tabitha', 'tamara', 'tamia', 'tamina', 'tania', 'tanja', 'tara', 'tatiana', 'tatjana',
  'tea', 'teodora', 'teresa', 'teri', 'tess', 'tessa', 'thea', 'thekla', 'thelma',
  'theresa', 'therese', 'theresia', 'tiffany', 'tilda', 'timea', 'tina', 'tine', 'tomke',
  'tonja', 'tracy', 'trine', 'trudi', 'tuana', 'tuba',
  // U–Z
  'ula', 'ulla', 'ulrike', 'undine', 'ursel', 'ursula', 'ute', 'valentina', 'valentine',
  'valeria', 'valerie', 'vanessa', 'vera', 'verena', 'veronica', 'veronika', 'vesna', 'victoria',
  'viktoria', 'viola', 'violet', 'violeta', 'violetta', 'virginia', 'vivian', 'viviane',
  'vivien', 'vivienne', 'walburga', 'waltraud', 'wendy', 'wenke', 'whitney',
  'wiebke', 'wilhelmine', 'wilma', 'winona', 'xenia', 'yael', 'yasemin', 'yasmin', 'yasmine',
  'yelda', 'yeliz', 'yesim', 'ylva', 'yvette', 'yvonne', 'zahra', 'zehra', 'zeynep', 'zina',
  'zoe', 'zoey', 'zofia', 'zora', 'zuzanna',
]);

const TITLES = new Set([
  'dr', 'dr.', 'prof', 'prof.', 'dipl', 'dipl.', 'ing', 'ing.', 'mag', 'mag.', 'med', 'med.',
  'phil', 'phil.', 'rer', 'nat', 'jur', 'hr', 'fr', 'herr', 'frau', 'mr', 'mr.', 'mrs', 'mrs.',
  'ms', 'ms.', 'sir',
]);

function normalizeToken(token) {
  return String(token || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zäöüß-]/gi, '')
    .replace(/ß/g, 'ss');
}

function extractFirstName(fullName) {
  const parts = String(fullName || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  for (const part of parts) {
    const clean = part.replace(/^[^\p{L}]+|[^\p{L}]+$/gu, '');
    const key = normalizeToken(clean.split('-')[0]);
    if (!key || TITLES.has(key) || TITLES.has(`${key}.`)) continue;
    // Bei Doppelnamen wie Hans-Peter / Anna-Lena: erstes Segment prüfen, sonst ganzes Token
    return clean;
  }
  return '';
}

function lookupName(firstName) {
  const raw = String(firstName || '').trim();
  if (!raw) return 'unknown';

  const segments = raw.split('-').map((s) => normalizeToken(s)).filter(Boolean);
  if (!segments.length) return 'unknown';

  // Alle Segmente männlich / weiblich?
  const genders = segments.map((seg) => {
    if (MALE.has(seg)) return 'male';
    if (FEMALE.has(seg)) return 'female';
    return null;
  });

  if (genders.every((g) => g === 'male')) return 'male';
  if (genders.every((g) => g === 'female')) return 'female';
  if (genders.some((g) => g === 'male') && !genders.some((g) => g === 'female')) return 'male';
  if (genders.some((g) => g === 'female') && !genders.some((g) => g === 'male')) return 'female';

  // Leichte Heuristik für unbekannte Namen
  const last = segments[segments.length - 1];
  if (/^(anna|maria|ine|ette|elle|ina|ika|ke)$/i.test(last)) return 'female';
  if (/(a|ine|ette|elle|ina|ika)$/i.test(last) && last.length > 3) return 'female';

  return 'unknown';
}

/**
 * Versucht das Geschlecht anhand bestehender Kontakte (Mehrheit) und sonst des Vornamens.
 * „Keine Angabe“ / unknown zählt nicht zur Mehrheit.
 * @param {string} fullName
 * @param {Array<{ name?: string, gender?: string, id?: number|string }>} [existingContacts]
 * @param {{ excludeId?: number|string }} [options]
 * @returns {'male'|'female'|'unknown'}
 */
export function guessGenderFromName(fullName, existingContacts = [], options = {}) {
  const fromContacts = majorityGenderFromContacts(fullName, existingContacts, options);
  if (fromContacts !== 'unknown') return fromContacts;
  const first = extractFirstName(fullName);
  if (!first) return 'unknown';
  return lookupName(first);
}

/**
 * Mehrheit der gespeicherten Geschlechter für denselben Vornamen.
 * unknown wird ignoriert. Bei Gleichstand → unknown.
 */
export function majorityGenderFromContacts(fullName, existingContacts = [], options = {}) {
  const first = extractFirstName(fullName);
  if (!first) return 'unknown';

  const targetKey = normalizeToken(first);
  if (!targetKey) return 'unknown';

  let male = 0;
  let female = 0;

  for (const contact of existingContacts || []) {
    if (options.excludeId != null && String(contact.id) === String(options.excludeId)) continue;

    const gender = String(contact.gender || '').toLowerCase();
    if (gender !== 'male' && gender !== 'female') continue;

    const contactFirst = extractFirstName(contact.name);
    if (!contactFirst) continue;
    if (normalizeToken(contactFirst) !== targetKey) continue;

    if (gender === 'male') male += 1;
    else female += 1;
  }

  if (male === 0 && female === 0) return 'unknown';
  if (male > female) return 'male';
  if (female > male) return 'female';
  return 'unknown';
}

export { extractFirstName };
